module.exports = __webpack_public_path__ + "img/logo-navbar.ac1bf7fa.svg";